export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="font-heading text-lg font-bold text-background-50 mb-4">韩国漫画</h3>
            <p className="text-sm leading-relaxed text-background-50/60">
              韩国漫画网站致力于打造最全面的韩国漫画网站大全，为韩国漫画爱好者提供免费韩国漫画网站推荐、排行与入口导航服务。
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#carousel" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">热门专题</a></li>
              <li><a href="#cards" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">精选推荐</a></li>
              <li><a href="#ranking" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">人气排行</a></li>
              <li><a href="#updates" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">最新动态</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">题材分类</h4>
            <ul className="space-y-2">
              <li><a href="#index" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">动作冒险</a></li>
              <li><a href="#index" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">奇幻世界</a></li>
              <li><a href="#index" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">浪漫爱情</a></li>
              <li><a href="#index" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">悬疑推理</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/60 leading-relaxed">
              合作伙伴信息将在后续更新中展示，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2024 韩国漫画网站 - 韩国漫画网站大全 | 免费韩国漫画网站推荐与排行
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">回到顶部</a>
            <a href="#contact" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">联系投稿</a>
          </div>
        </div>
      </div>
    </footer>
  );
}